module.exports = __webpack_public_path__ + "static/img/virtualReality5.8720e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality5.png
// module id = 5Ybl
// module chunks = 13